module.exports = __webpack_public_path__ + "static/media/Group 320.a7cf8ab0.svg";